const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`, `5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`, 1, 112), new Map([[`class`, `o-container--prose o-container--pad-inline u-pad-block-1`], [`alignment`, (context.has(`alignment`) ? context.get(`alignment`) : null)], [`ratio`, (context.has(`ratio`) ? context.get(`ratio`) : null)], [`caption`, (context.has(`caption`) ? context.get(`caption`) : null)]]), false, false, 1));
            }

            getTemplateName() {
                return `5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`, ``);
            }
        }],
        [112, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <figure class="wp-block-embed is-type-rich is-provider-speakerdeck wp-block-embed-speakerdeck
      wp-embed-aspect-`);
                this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, (((context.has(`ratio`))) ? (this.env.getFilter('default').traceableCallable(9, this.source)(...[(context.has(`ratio`) ? context.get(`ratio`) : null), `16-9`])) : (`16-9`)), `html`, null, true]));
                this.echo(` wp-has-aspect-ratio
      `);
                if ((context.has(`alignment`) ? context.get(`alignment`) : null)) {
                    this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, (context.has(`alignment`) ? context.get(`alignment`) : null), `html`, null, true]));
                }
                this.echo(`">
      <div class="wp-block-embed__wrapper">
        <iframe loading="lazy" title="Imagining a Fluid Future for Design Tools" id="talk_frame_974667" class="speakerdeck-iframe" src="//speakerdeck.com/player/2082db2379d94e04a3869d64ca9653fd" width="500" height="281" style="aspect-ratio:500/281; border:0; padding:0; margin:0; background:transparent;" frameborder="0" allowtransparency="true" allowfullscreen="allowfullscreen"></iframe>
      </div>
      `);
                if ((context.has(`caption`) ? context.get(`caption`) : null)) {
                    this.echo(`        <figcaption class="wp-element-caption">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, (context.has(`caption`) ? context.get(`caption`) : null), `html`, null, true]));
                    this.echo(`</figcaption>
      `);
                }
                this.echo(`    </figure>
  `);
            }

            getTemplateName() {
                return `5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d');

let template = env.loadTemplate('5c1048d7e239f83618a0e0e5feb2d97617697ec733d6280c6bb76706260e802d');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/embed/speakerdeck.twig", args: context }
     );
     return rendered;;
};